// import { Fragment  } from "react"; React from "react";
import { getBoxToBoxArrow } from "curved-arrows";

export default function Arrows({ edges, cards }) {
  const offset = 50000;

  return (
    <svg
      width={offset * 2}
      height={offset * 2}
      style={{
        transform: `translate(${-offset}px, ${-offset}px)`,
        position: "absolute",
        zIndex: "-40000000",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      {edges.map((edge, i) => {
        return (
          <Path
            key={i}
            offset={offset} //
            fromCard={cards[edge.fromCard]}
            toCard={cards[edge.toCard]}
          />
        );
      })}
    </svg>
  );
}

function Path({ fromCard, toCard, offset }) {
  const arrowHeadSize = 9;
  const color = "var(--canvas-cta)";

  const [sx, sy, c1x, c1y, c2x, c2y, ex, ey, ae] = getBoxToBoxArrow(fromCard.x, fromCard.y, fromCard.width, fromCard.height, toCard.x, toCard.y, toCard.width, toCard.height, {
    padStart: 0,
    padEnd: arrowHeadSize,
  });

  return (
    <>
      <path
        d={`M ${sx + offset} ${sy + offset} C ${c1x + offset} ${c1y + offset}, ${c2x + offset} ${c2y + offset}, ${ex + offset} ${ey + offset}`}
        stroke={color}
        strokeWidth={arrowHeadSize / 2}
        fill="none"
      />
      <polygon
        points={`0,${-arrowHeadSize} ${arrowHeadSize * 2},0, 0,${arrowHeadSize}`}
        transform={`translate(${ex + offset}, ${ey + offset}) rotate(${ae})`}
        fill={color}
      />
    </>
  );
}
